// extracted by mini-css-extract-plugin
export var close = "SiteNavigation-module--close--46c1c";
export var enter = "SiteNavigation-module--enter--83694";
export var enterActive = "SiteNavigation-module--enterActive--0fff5";
export var enterDone = "SiteNavigation-module--enterDone--0c1e9";
export var exit = "SiteNavigation-module--exit--53a02";
export var exitActive = "SiteNavigation-module--exitActive--758ff";
export var item = "SiteNavigation-module--item--0f29a";
export var list = "SiteNavigation-module--list--d2b72";
export var open = "SiteNavigation-module--open--47983";
export var panel = "SiteNavigation-module--panel--8f49a";
export var root = "SiteNavigation-module--root--45c3d";
export var toggle = "SiteNavigation-module--toggle--68417";